// Vorlauf einer Vorbestellung als Text, inklusive Aufschlag für Spezialfahrten
// (Rollstuhl/Tragestuhl/Liegend). Ohne den Hinweis wirkt ein früherer
// Freigabezeitpunkt wie ein Fehler.
// nextcab_mobile/docs/general/spezialfahrten_vorlauf_konzept.md §4.3

const EXTRA_LEAD_LABELS = {
  rollstuhl: 'Rollstuhl',
  tragestuhl: 'Tragestuhl',
  liegend: 'Liegend',
};

// „30 Min. Vorlauf, davon 15 Min. Rollstuhl" bzw. „15 Min. Vorlauf"; null ohne Wert.
export const formatPreorderLead = (ride) => {
  if (!Number.isFinite(ride?.preorderDispatchLeadMinutes)) return null;
  const base = `${ride.preorderDispatchLeadMinutes} Min. Vorlauf`;
  const extra = Number(ride.preorderDispatchExtraLeadMinutes) || 0;
  if (extra <= 0) return base;
  const label = EXTRA_LEAD_LABELS[ride.preorderDispatchExtraLeadReason] || 'Spezialfahrt';
  return `${base}, davon ${extra} Min. ${label}`;
};
